import React, {useEffect, useRef, useState} from "react";
import "./Events.scss"
import Swiper from "swiper";
import 'swiper/swiper-bundle.min.css'
import {useHistory, useLocation} from "react-router-dom";
import {Nav} from "../../Components";
import {EventsData} from "./EventsServices";

function Events() {


    //hooks
    const history = useHistory();
    const location = useLocation()

    //states
    const [events,setEvents] = useState(null);
    const [introduction,setIntroduction] = useState(null);
    const [preload, setPreload] = useState(true);
    const [failed, setFailed] = useState(false);


    // DualSliderDesktop Functions -------------------------------------
    const swiper = useRef(null)
    const Loop = ()=>{
        setInterval(()=>{
            swiper.current.slideNext();
        },2000)
    }

    useEffect(()=>{
        getEvents();
        swiper.current=new Swiper('.swiper-container',{
            loop:true,
            autoplay: {
                delay: 5000,
            },
        })
        //Loop();
    },[])

    //fetch events ------------------------------------------------------
    const getEvents = async () => {
        try{
            let response = await EventsData();
            let list = response.data.filter(item=>!item.is_introduction);
            if(list){setEvents(list)};
            let intro = response.data.filter(item=>item.is_introduction);
            if(intro){setIntroduction(intro[0])}
            setPreload(false)
        }catch (e) {
            setFailed(true)
            // console.log(e);
        }
    }

    const [nav_label,set_nav_label] = useState(null)

    useEffect(()=>{
        if(location.state && location.state.navLabel)
            set_nav_label(location.state.navLabel)
    },[])


    return(
        <div className="events-container page">
            <div className="events-header">
                <span>{nav_label?nav_label:"رویدادها"}</span>
            </div>
            {!preload?<div>
               <div className="events-slider">
                   {introduction?<div className="swiper-container swiper1">
                       <div className="swiper-wrapper">
                           <div className="swiper-slide"><img src={introduction.cover}/></div>
                       </div>
                   </div>:null}
               </div>
               <div className="events_list">

                   {events && events.map(event=>{
                       return(
                           <div key={event.uid} className="events_list_item" onClick={()=>history.push(`/event-detail/${event.uid}`,{event:event})}>
                               <div className="events_list_item_info">
                                   <span className="events_list_item_title">{event.title}</span>
                                   <span className="events_list_item_date">{event.subtitle}</span>
                                   {/*<span className="events_list_item_time">ساعت 23:59</span>*/}
                               </div>
                               <img src={event.image || event.cover} alt=""/>
                           </div>
                       )
                   })

                   }

               </div>
           </div>: <div className="customer-preLoading">
            {!failed ? <div className="customer-preloading-body">
                <img src="/svg/pre.gif" alt=""/>
            </div> : <div className="customer-failed-body">
                <img src="/svg/failed.svg" alt=""/>
                <span>اطلاعاتی موجود نیست</span>
            </div>}
        </div>}
            <Nav/>
        </div>
    )

}

export {Events};
